'use strict';Object.defineProperty(exports,'__esModule',{value:!0});var _FormControl=require('./FormControl');Object.defineProperty(exports,'default',{enumerable:!0,get:function get(){return _interopRequireDefault(_FormControl).default}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}


/** WEBPACK FOOTER **
 ** ./~/@vitalsource/vstui/FormControl/index.js
 **/